import { Box } from "@mui/system";
import Image from "next/image";

import bbcAsiaLogo from "public/images/featured-in-bbc-asian-network.png";
import eveningStandardLogo from "public/images/featured-in-evening-standard.png";
import itvLogo from "public/images/featured-on-itv.png";
import lbcLogo from "public/images/featured-on-lbc-london-news.png";
import metroLogo from "public/images/featured-in-the-metro.png";

export default function FeaturedOn () {
  return (
    <Box>
    <section id="partners">
      <Box pb={6}>
        <h2>
          We've Been<span> Featured On:</span>
        </h2>
      </Box>
      <div className="row justify-content-center">
        <div>
          <Image src={bbcAsiaLogo} alt="Featured on BBC Radio Asian Network" />
        </div>
        <div>
          <Image src={eveningStandardLogo} alt="Featured in The Evening Standard" />
        </div>
        <div>
          <Image src={itvLogo} alt="Featured on ITV" />
        </div>
        <div>
          <Image src={lbcLogo} alt="Featured on LBC London News" />
        </div>
        <div>
          <Image src={metroLogo} alt="Featured in The Metro" />
        </div>
      </div>
    </section>
  </Box>
  )
}